import api from '@/plugins/api';
import component from './component.vue';

export default class TourBoard {
  component = component;
  __items = [];
  loading = false;
  __tourInfo = {};

  get items() {
    return this.__items;
  }

  get tour() {
    return this.__tourInfo;
  }

  set(data) {
    this.__items = data;
  }

  init() {
    this.loading = false;
  }

  submit(from, to) {
    this.__items = [];
    this.loading = true;
    const request = {
      'DateStart.Serialized': from,
      'DateEnd.Serialized': to,
    };
    return api.tour.admin
      .board(request)
      .then((data) => {
        this.set(data.items?.map(i => ({
          ...i
        })) || []);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
  }

  get(request) {
    this.loading = true;
    return api.tour.admin
      .getItem(request)
      .then((data) => {
        this.__tourInfo = data;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
  }
}
